import type { ReactElement } from 'react'
import packageJson from '../../package.json'
import { useT } from '../i18n/useI18n'
import './About.css'

export default function About(): ReactElement {
  const t = useT()
  const version = packageJson.version as string

  return (
    <div className="about-container">
      {/* Hero */}
      <section className="about-hero">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <img src="/logo.svg" alt="StructuraMatrix" className="about-logo mb-4" />
              <h1 className="about-title">
                Structura<span className="highlight">Matrix</span>
              </h1>
              <p className="about-subtitle">{t('about.subtitle')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="about-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <div className="mission-card">
                <div className="mission-visual">
                  <div className="mission-shell"></div>
                  <div className="mission-grid"></div>
                </div>
                <div className="mission-copy">
                  <h2 className="about-section-title">{t('about.mission.heading')}</h2>
                  <p className="mission-text">{t('about.mission.text')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="about-section team-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <div className="team-card">
                <div className="team-visual">
                  <div className="team-shell"></div>
                  <div className="team-grid"></div>
                  <div className="team-orbit"></div>
                </div>
                <div className="team-copy">
                  <h2 className="about-section-title">{t('about.team.heading')}</h2>
                  <p className="team-intro">{t('about.team.intro')}</p>
                  <div className="team-details">
                    <p>{t('about.team.para1')}</p>
                    <p>{t('about.team.para2')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Logo philosophy */}
      <section className="about-section logo-section">
        <div className="container">
          <div className="row justify-content-center align-items-center g-4">
            <div className="col-lg-4 text-center">
              <img src="/logo.svg" alt="StructuraMatrix" className="logo-large" />
            </div>
            <div className="col-lg-7">
              <h2 className="about-section-title">{t('about.logo.heading')}</h2>
              <p className="logo-description">{t('about.logo.para1')}</p>
              <p className="logo-description">{t('about.logo.para2')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Version */}
      <section className="about-section version-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="version-card">
                <h2 className="about-section-title">{t('about.version.heading')}</h2>
                <div className="version-info">
                  <div className="version-row">
                    <span className="version-label">{t('about.version.current')}</span>
                    <span className="version-value">{version}</span>
                  </div>
                  <div className="version-row">
                    <span className="version-label">{t('about.version.released')}</span>
                    <span className="version-value">{t('about.version.releaseDate')}</span>
                  </div>
                  <div className="version-row">
                    <span className="version-label">{t('about.version.platform')}</span>
                    <span className="version-value">{t('about.version.platformValue')}</span>
                  </div>
                  <div className="version-row">
                    <span className="version-label">{t('about.version.status')}</span>
                    <span className="version-value">
                      <span className="about-status-badge">{t('about.version.statusValue')}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}
